module.exports = __webpack_public_path__ + "static/media/distance.8ecb0f8f.svg";